import React, { useState } from "react";
import "../../Styles/DashboardFeedback.css";

const DashboardFeedback = () => {
  const [rate,setrate]=useState(null)
  return (
    <div className="dashboard-content">
      <div className="home-heading-container">
        <h1 className="heading-text-h1">Feedback</h1>
      </div>
      <hr className="dashboard-home-hr" />
      <div className="feedback-container">
        <h2 className="feedback-heading">How are you feeling?</h2>
        <div className="emoji-container">
          <h2 className={rate===1 ? "emoji-active":"emoji"} onClick={()=>{setrate(1)}}>😔</h2>
          <h2 className={rate===2 ? "emoji-active":"emoji"} onClick={()=>{setrate(2)}}>😞</h2>
          <h2 className={rate===3 ? "emoji-active":"emoji"} onClick={()=>{setrate(3)}}>😑</h2>
          <h2 className={rate===4 ? "emoji-active":"emoji"} onClick={()=>{setrate(4)}}>😊</h2>
          <h2 className={rate===5 ? "emoji-active":"emoji"} onClick={()=>{setrate(5)}}>😄</h2>
        </div>
        <textarea type="text" placeholder="Write your Feedback" className="feedback-input"/>

        <button className="request-submit-btn">Submit Feedback</button>
      </div>
    </div>
  );
};

export default DashboardFeedback;
